<template>
    <div>
        <form :action="route" method="POST" id="share_markups" name="share_markups">
            <input type="hidden" name="uuid" id="shareMarkupUuid" v-model="uuid">
            <div class="form-group">
                <label for="share_emails">{{ "Invite to collaborate" }}</label>
                <br />
                <div class="mt-3">
                    <div class="input-group mb-3">
                        <input type="text" v-model="emailAddress" placeholder="email address" class="form-control"
                            aria-label="email address to share project with" />
                        <button class="btn btn-outline-secondary dropdown-toggle" type="button"
                            data-bs-toggle="dropdown" data-bs-auto-close="outside" aria-expanded="false"
                            v-text="selectedPermission.toTitleCase()"></button>
                        <ul class="dropdown-menu dropdown-menu-end">
                            <div class="list-group list-group-checkable d-grid gap-2 border-0 w-auto">
                                <input class="list-group-item-check pe-none" type="radio"
                                    name="collaboratorMarkupAccess" id="collaboratorMarkupAccess1" value="view"
                                    @click="selectedPermission = 'view'">
                                <label class="list-group-item py-3" for="collaboratorMarkupAccess1">
                                    View
                                    <span class="d-block small opacity-50"
                                        v-text="'Allow a guest to only view the project'"></span>
                                </label>

                                <input class="list-group-item-check pe-none" type="radio"
                                    name="collaboratorMarkupAccess" id="collaboratorMarkupAccess2" value="comment"
                                    @click="selectedPermission = 'comment'">
                                <label class="list-group-item py-3" for="collaboratorMarkupAccess2">
                                    Comment
                                    <span class="d-block small opacity-50"
                                        v-text="'Allows a guest to make comments on points of the project'"></span>
                                </label>

                                <input class="list-group-item-check pe-none" type="radio"
                                    name="collaboratorMarkupAccess" id="collaboratorMarkupAccess3" value="edit"
                                    @click="selectedPermission = 'edit'">
                                <label class="list-group-item py-3" for="collaboratorMarkupAccess3">
                                    Edit
                                    <span class="d-block small opacity-50"
                                        v-text="'User will have edit rights, they will also need to create an account'"></span>
                                </label>
                            </div>
                        </ul>
                    </div>
                </div>
                <!-- <div class="input-group">
                    <input type="text" class="form-control" id="share_emails" name="emails"
                        placeholder="second@email.com" v-model="email" />
                </div> -->
                <div v-if="submit_error" id="share_emails_validation" class="invalid-feedback">
                    Please provide valid email addresses
                </div>
                <small id="share_help_text" class="form-text text-muted">Separate emails using commas. These
                    will be emailed to the people with a link that requires them to use their email to
                    access</small>
            </div>
        </form>
    </div>
</template>

<script>
import axios from 'axios';

export default {
    props: ['route', 'uuid'],
    data() {
        return {
            emailAddress: null,
            selectedPermission: 'view',
            submit_error: false,
            collaborators: [],
        }
    },

    methods: {
        handleSubmit() {
            axios
                .post(
                    this.route,
                    {
                        email: this.emailAddress,
                        permission: this.selectedPermission,
                    }
                )
                .then(_r => {})
                .catch(e => console.error(e))
        }
    },

    mounted() {
        //
    }
}
</script>
